import React from 'react';
import PropTypes from 'prop-types';

const QuestionPalette = ({ questions, answers, currentQuestion, onQuestionSelect, onClose }) => {
  const getQuestionStatus = (questionId) => {
    const answer = answers[questionId];
    if (!answer) return 'unanswered';
    if (answer.isMarked) return 'marked';
    if (answer.selectedOption !== null) return 'answered';
    return 'unanswered';
  };

  const getStatusClass = (status, isCurrent) => {
    if (isCurrent) return 'question-current';
    switch (status) {
      case 'answered': return 'question-answered';
      case 'marked': return 'question-marked';
      default: return 'question-unanswered';
    }
  };

  const statusCounts = {
    answered: Object.keys(answers).filter(id => answers[id]?.selectedOption !== null && !answers[id]?.isMarked).length,
    marked: Object.keys(answers).filter(id => answers[id]?.isMarked).length,
    unanswered: questions.length - Object.keys(answers).filter(id => answers[id]?.selectedOption !== null).length
  };

  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Question Palette</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="grid grid-cols-3 gap-2 text-xs">
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-green-100 border border-green-300 rounded"></div>
            <span>Answered ({statusCounts.answered})</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-yellow-100 border border-yellow-300 rounded"></div>
            <span>Marked ({statusCounts.marked})</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-gray-100 border border-gray-300 rounded"></div>
            <span>Not Answered ({statusCounts.unanswered})</span>
          </div>
        </div>

      </div>

      <div className="flex-1 p-4 overflow-y-auto">
        <div className="grid grid-cols-5 gap-2">
          {questions.map((question, index) => {
            const status = getQuestionStatus(question._id);
            const isCurrent = index === currentQuestion;
            
            return (
              <button
                key={question._id}
                onClick={() => onQuestionSelect(index)}
                className={`w-10 h-10 text-sm font-medium rounded border-2 transition-colors ${getStatusClass(status, isCurrent)}`}
              >
                {index + 1}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

QuestionPalette.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    en: PropTypes.shape({
      value: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(PropTypes.shape({
        prompt: PropTypes.number.isRequired,
        value: PropTypes.string.isRequired
      })).isRequired
    }).isRequired,
    sectionName: PropTypes.string,
    questionNumber: PropTypes.number
  })).isRequired,
  answers: PropTypes.objectOf(PropTypes.shape({
    selectedOption: PropTypes.number,
    isMarked: PropTypes.bool.isRequired,
  })).isRequired,
  currentQuestion: PropTypes.number.isRequired,
  onQuestionSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default QuestionPalette; 